export default
{
    legend: {
        layout: 'vertical', align:'center', verticalAlign: 'bottom'

    },
    credits: {
        enabled:false
    },
    chart: {
        type: 'areaspline',
        animation: false,
        height: '500px',
    },
    title: {
        text: 'Vodný stav (cm)'
    },
    subtitle: {
        text: null
    },
    xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
            month: '%e. %b',
            year: '%b',
            hour: '%H:%M'
        },
        gridLineWidth: 1,
        gridLineColor: 'rgba(200,200,200,0.3)',
        lineColor: '#000',
        lineWidth: 1,
        tickColor: '#000',

        tickInterval: 24 * 60 * 60 * 1000,

        minorGridLineColor: 'rgba(8,8,8,0.3)',

        labels: {
            rotation: -90,
            y:20
        },
        startOnTick: false,
        endOnTick: false,
        minPadding: 0,
        maxPadding: 0,
        plotLines: [
            /*
            // ciary pre dni
            { color: '#aaa', width: 1, value: 1584748800000},
            { color: '#aaa', width: 1, value: 1584835200000},
            { color: '#aaa', width: 1, value: 1584921600000},
            { color: '#aaa', width: 1, value: 1585008000000},
            { color: '#aaa', width: 1, value: 1585094400000},
            { color: '#aaa', width: 1, value: 1585180800000},
            { color: '#aaa', width: 1, value: 1585267200000},
            { color: '#aaa', width: 1, value: 1585353600000},
            { color: '#aaa', width: 1, value: 1585440000000},
            { color: '#aaa', width: 1, value: 1585526400000},
            { color: '#aaa', width: 1, value: 1585612800000},
            { color: '#aaa', width: 1, value: 1585699200000},
            { color: '#aaa', width: 1, value: 1585785600000},
            { color: '#aaa', width: 1, value: 1585872000000}
            */
            ]


    },
    yAxis: [{
        min: 0,
        opposite: true,
        // max: max_y,
        title: null,

        minorTickInterval: 50,
        minorGridLineWidth:1,
        minorGridLineColor: 'rgba(200,200,200,0.1)',
        gridLineColor: 'rgba(200,200,200,0.2)',

        lineColor: '#000',
        lineWidth: 1,
        tickWidth: 1,
        //tickInterval: 100,
        tickColor: '#000',
        plotBands:[
        ],
        plotLines:[],

    },{
        lineColor: '#000',
        lineWidth: 1,
        tickWidth: 1,
        //tickInterval: 100,
        tickColor: '#000',
        title: null,
        labels: {
            enabled: false
        },
    }],
    tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table class="noborder">',
        pointFormat: '<tr><td style="color:{series.color};padding:0;background:none;font-weight:bold;">{series.name}: </td>' +
            '<td style="padding:0;background:none;color:#000">&nbsp;<b>{point.y:.0f} cm</b></td></tr>',
        footerFormat: '</table>',
        shared: true,
        useHTML: true,
        backgroundColor: 'rgba(255, 255, 255, 0.85)',
        followPointer: true
    },
    plotOptions: {
        areaspline: {
            animation: false,
            fillcolor: '#6B72B7',
            fillOpacity: 0.5,
            events: {
                legendItemClick: function () {
                    return false;
                }
            },
            marker: {
                enabled: false,
                symbol: 'circle',
                radius: 2,
                states: {
                    hover: {
                        enabled: true,
                        lineWidthPlus: 2
                    }
                }
            },
            states: {
                hover: {
                    enabled: true,
                    lineWidthPlus: 0
                }
            }
        },
        spline: {
            animation: false,
            events: {
                legendItemClick: function () {
                    return false;
                }
            },
            marker: {
                enabled: false,
                symbol: 'circle',
                radius: 2,
                states: {
                    hover: {
                        enabled: true,
                        lineWidthPlus: 2
                    }
                }
            },
            states: {
                hover: {
                    enabled: true,
                    lineWidthPlus: 0
                }
            }
        },
        states:{
            hover:{
                enabled:true
            }
        },
        series: {
            states:{
                inactive: {
                    opacity: 1
                }
            },

        }
    },
    series: [
        {id:'m', name:'Meraný vodný stav', showInLegend: true, color:'#000080', lineWidth:2, data:[]},
        {id:'f',  fillOpacity: 0.2, name:'Modelová predpoveď vodného stavu', showInLegend: true, color:'#0096FF', lineWidth:2, data:[]},
        {id:'spa1',  name:'1.SPA', showInLegend: true, color:'rgba(255, 255, 0, 0.65)', data:[]},
        {id:'spa2',  name:'2.SPA', showInLegend: true, color:'rgba(255, 153, 0, 0.65)', data:[]},
        {id:'spa3',  name:'3.SPA', showInLegend: true, color:'rgba(255, 31, 0, 0.65)', data:[]}
        ]
}